import { render, staticRenderFns } from "./slideShow.vue?vue&type=template&id=4a0705b1&scoped=true&"
import script from "./slideShow.vue?vue&type=script&lang=js&"
export * from "./slideShow.vue?vue&type=script&lang=js&"
import style0 from "./slideShow.vue?vue&type=style&index=0&id=4a0705b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0705b1",
  null
  
)

export default component.exports